import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { payWithRevolut, euro } from "@/lib/revolutPay";

export function CycleToggle({ cycle, setCycle, testid = "cycle-toggle" }) {
  return (
    <div data-testid={testid} className="inline-flex rounded-full border border-zinc-800 bg-zinc-950 p-1 text-xs font-medium">
      {[["monthly", "Mensuel"], ["yearly", "Annuel · 2 mois offerts"]].map(([k, l]) => (
        <button key={k} type="button" data-testid={`${testid}-${k}`} onClick={() => setCycle(k)}
          className={`rounded-full px-3 py-1.5 transition-colors ${cycle === k ? "bg-[#FF6A00] text-white" : "text-zinc-400 hover:text-white"}`}>{l}</button>
      ))}
    </div>
  );
}

export default function PlanPicker({ offer, rev, onDone }) {
  const [cycle, setCycle] = useState(offer.current.cycle || "monthly");
  const [busy, setBusy] = useState("");
  const cur = offer.current;
  const subscribe = async (key) => {
    if (rev && !rev.configured) { toast.error("Le paiement en ligne est momentanément indisponible, réessayez plus tard."); return; }
    if (!rev?.plans?.[key] || (cycle === "yearly" && !rev.plans[key].yearly)) { toast.error("Cette formule n'est pas encore configurée. Contactez le support."); return; }
    setBusy(key);
    try {
      const { data } = await api.post("/revolut/subscribe", { plan: key, cycle });
      await payWithRevolut(data, { save: true, onSuccess: () => { toast.success("Abonnement activé — merci !"); setTimeout(onDone, 1500); }, onError: () => toast.error("Le paiement Revolut a échoué.") });
    } catch (e) { toast.error(e.response?.data?.detail || e.message || "Erreur"); }
    finally { setBusy(""); }
  };
  return (
    <div className="mt-5 space-y-4">
      <CycleToggle cycle={cycle} setCycle={setCycle} />
      <div className="grid gap-3 sm:grid-cols-3">
        {offer.plans.map((p) => {
          const current = cur.plan === p.key && cur.status === "active" && cur.cycle === cycle;
          const price = cycle === "yearly" ? p.price_yearly : p.price_monthly;
          return (
            <div key={p.key} data-testid={`plan-${p.key}`} className={`relative flex flex-col rounded-2xl border p-4 transition-colors ${current ? "border-[#FF6A00] bg-[#FF6A00]/10" : p.highlighted ? "border-[#FF6A00]/50 bg-zinc-950" : "border-zinc-800 bg-zinc-950"}`}>
              {p.badge && <span className="absolute -top-2.5 left-4 rounded-full bg-[#FF6A00] px-2 py-0.5 text-[10px] font-semibold text-white">{p.badge}</span>}
              <p className="font-display text-base font-bold text-white">{p.name}</p>
              <p className="mt-1"><span data-testid={`plan-${p.key}-price`} className="font-display text-2xl font-bold text-white">{euro(price)}</span><span className="text-xs text-zinc-500"> HT /{cycle === "yearly" ? "an" : "mois"}</span></p>
              <p className="mt-1 text-xs text-zinc-500">{p.audience}</p>
              <ul className="mt-2 space-y-0.5 text-[11px] text-zinc-400">
                <li>{p.users_included} utilisateur{p.users_included > 1 ? "s" : ""} inclus</li><li>{p.modules_text}</li><li>{p.storage_gb} Go de stockage</li>
              </ul>
              <Button data-testid={`choose-plan-${p.key}`} onClick={() => subscribe(p.key)} disabled={busy === p.key || current}
                className={`mt-4 w-full rounded-full text-xs font-semibold text-white ${current ? "cursor-default bg-zinc-700 hover:bg-zinc-700" : "bg-[#FF6A00] hover:bg-[#E65F00]"}`}>
                {current ? "Plan actuel" : cur.status === "active" ? "Changer" : "Choisir"}
              </Button>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-zinc-500">Prix hors taxes. L'abonnement annuel est réglé en une fois et correspond à deux mois offerts.</p>
    </div>
  );
}
